import { useState } from 'react'
import { AVAILABLES_LEVEL } from '../helpers'

const getAvailableLevelOrder = (level) => {
  const index = AVAILABLES_LEVEL.findIndex(({ value }) => value === level)
  return index === -1 ? AVAILABLES_LEVEL.length : index
}

const useSort = ({ defaultOrderBy = 'label' }) => {
  const [orderBy, setOrderBy] = useState(defaultOrderBy)
  const [orderDirection, setOrderDirection] = useState<'asc' | 'desc' | undefined>('desc')

  const handleOrderBy = (newOrderBy) => {
    setOrderBy(newOrderBy)
    if (orderDirection !== 'desc') {
      setOrderDirection('desc')
    }
  }

  const handleOrderDirection = (newOrderDirection?: 'asc' | 'desc' | undefined) => {
    if (newOrderDirection) {
      if (['desc', 'asc'].includes(newOrderDirection)) {
        setOrderDirection(newOrderDirection)
      }
    } else {
      setOrderDirection((prev) => (prev === 'desc' ? 'asc' : 'desc'))
    }
  }

  const compare = (a, b) => {
    if (orderBy === 'available_level') {
      return getAvailableLevelOrder(a[orderBy]) - getAvailableLevelOrder(b[orderBy])
    }
    if (!a[orderBy] || !b[orderBy]) {
      return 0
    }
    return a[orderBy].toString().localeCompare(b[orderBy], 'en', {numeric : true})
  }

  const compareSite = (a, b) => {
    if (!a.site || !b.site) {
      return 0
    }
    if (a.site && b.site) {
      return a.site.name.localeCompare(b.site.name)
    } else if (a.name && b.name) {
      return a.name.localeCompare(b.name)
    }

    return 0
  }

  const compareSsid = (a, b) => {
    if (a.name && b.name) {
      return a.name.localeCompare(b.name)
    }
    return 0
  }

  const compareLabel = (a, b) => {
    if (a.label && b.label) {
      return a.label.localeCompare(b.label, undefined, {numeric: true})
    }
    return 0
  }

  const compareStatus = (a, b) => {

    const statusA = a.equipment ? a.equipment.available_level : 'down'
    const statusB = b.equipment ? b.equipment.available_level : 'down'

    if (statusA === statusB) {
      if (orderDirection === 'asc') {
        return compareSite(b, a)
      } else {
        return compareSite(a, b)
      }
    }

    const order = ['down', 'degraded', 'up']
    return order.indexOf(statusA) - order.indexOf(statusB)
  }

  const compareStatusOnDevices = (a, b) => {

    const statusA = a.is_reachable
    const statusB = b.is_reachable

    if (statusA === statusB) {
      return compareLabel(a, b)
    }

    const order = [false, true]
    return order.indexOf(statusA) - order.indexOf(statusB)

  }

  const sort = (equipments) => {

    return equipments && [...equipments].sort((a, b) => {
      if (orderDirection === 'desc') {
        if (orderBy === 'site_name') {
          return compareSite(a, b)
        } else if (orderBy === 'name') {
          return compareSsid(a, b)
        } else if (orderBy === 'label') {
          return compareLabel(a, b)
        } else if (orderBy === 'status') {
          return compareStatus(a, b)
        } else if (orderBy === 'devices_status') {
          return compareStatusOnDevices(a, b)
        } else {
          return compare(a, b)
        }
      } else {
        if (orderBy === 'site_name') {
          return compareSite(b, a)
        } else if (orderBy === 'name') {
          return compareSsid(b, a)
        } else if ( orderBy === 'label') {
          return compareLabel(b, a)
        } else if (orderBy === 'status') {
          return compareStatus(b, a)
        } else if (orderBy === 'devices_status') {
          return compareStatusOnDevices(b, a)
        } else {
          return compare(b, a)
        }
      }
    })
  }

  return {
    orderByChange: (newOrderBy) => {
      if (newOrderBy === orderBy) {
        handleOrderDirection()
      } else {
        handleOrderBy(newOrderBy)
      }
    },
    orderBy,
    orderDirection,
    sort,
  }
}

export default useSort
